(function ($, Drupal, drupalSettings) {
  'use strict';
  Drupal.behaviors.trailsBywaysMap = {
    attach: function (context, settings) {
      $('.block-trails-byways-map').each(function () {
        $('[data-sign]').on('click', function () {
          var trail = $(this).data('sign');
          trailsBywaysMapController(trail);
        });
        trailsBywaysMapSlider();
        // Init Slick
        function trailsBywaysMapSlider() {
          $('.view-trails-and-byways-map .view-content').not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true
          });
        }
        function trailsBywaysMapController(trail) {
          $('.trailways-map-trail-path-wrapper').each(function () {
            if ($(this).data('path') === trail && !$(this).hasClass('js-display')) {
              $(this).addClass('js-display');
              var slideNum = $(this).data('slide');
              $('.view-trails-and-byways-map .view-content').slick('slickGoTo', slideNum - 1);
            }
            else {
              $(this).removeClass('js-display');
            }
          });
        }
      });
    }
  };

  Drupal.behaviors.trailsLandingFilters = {
    attach: function (context, settings) {
      var $formElement = $('.tnv-trails-landing-filters-form');

      // Track if we should redirect to a new region or city.
      $('.form-item-location', $formElement).pSelect({
        default: null,
        searchElement: $('.form-item-location-city-search', $formElement),
        searchElementRegex: /^(\([0-9.,\- ]+\)) (.*)/g,
        onChange: function (option) {
          if (option) {
            if (option.data('filterType') !== 'cities') {
              window.location.href = option.data('filterValue');
            }
            if (option.data('filterType') === 'cities') {
              window.location.href = '/trails/all?selected-city=' + option.data('filterValue');
            }
          }
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
